<template>
  <div class="modalTable">
    <vxe-toolbar :loading="loading">
      <template v-slot:buttons>
        <el-button @click="getVehicleLength()">查询</el-button>
        <el-button type="primary" @click="getSelectEvent">获取选中</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      auto-resize
      stripe
      highlight-current-row
      :checkbox-config="{ highlight: true }"
      height="80%"
      :data="tableData"
      :loading="loading"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="code" title="车长编码" min-width="100" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.code"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" title="车长描述" min-width="100" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="remark" title="备注" min-width="100" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="status"
          :formatter="formatterisQuote"
          title="状态"
          min-width="100"
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { VehicleType } from "@/api/orderform";
export default {
  name: "Child",
  data() {
    return {
      loading: true,
      tableData: [],
      listQuery: {
        name: "",
        phone: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        type: "vehicleLength",
        status: "0",
        branchCode: ''
      },
      options: [
        {
          value: "0",
          label: "正常",
        },
      ],
      selectRecords: [],
    };
  },
  created() {},
  methods: {
    clearData() {
      this.listQuery = {
        name: "",
        phone: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        type: "vehicleLength",
        status: "0",
        branchCode: ''
      };
    },
    designcar(branchCode) {
      this.$refs.xTable.removeCheckboxRow()
      this.listQuery = {
        name: "",
        phone: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        type: "app_vehicleLength",
        status: "0",
        branchCode: ''
      }
      this.listQuery.branchCode = branchCode
      this.getVehicleLength();
    },
    getVehicleLength() {
      this.loading = true
      return VehicleType(this.listQuery).then((response) => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total
      }).finally(() => {this.loading = false})
    },
    getSelectEvent() {
      let selectRecords = this.$refs.xTable.getCheckboxRecords();
      if(selectRecords.length <= 0) {
        this.$message.warning("请至少选择一个车长")
      } else if (selectRecords.length > 3) {
        this.$message.warning("最多选择三个车长")
      } else {
        this.$emit("event", selectRecords);
      }
    },

    formatterisQuote({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "正常";
        case 1:
          return "停用";
        default:
          break;
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.getVehicleLength();
    },
  },
};
</script>

<style>
</style>
